<script>
  import Icon from "@shared/svelte/Components/Icon.svelte";

</script>

<button
  on:click
  class="fizz-flex-row-8 fizz-text-brand fizz-location-button fizz-hide-on-small retailer-select-button"
>
  <Icon type="LocationPin" extraClassNames="fizz-icon-24 fizz-text-brand" />
  <div>
    <p class="fizz-text-small">Ordering for</p>
    <p class="fizz-text-strong fizz-text-medium fizz-flex-row-4">
      <span class="fizz-truncate" style="--max-width: 25ch">Test Retailer</span>
      <Icon type="ChevronDown" extraClassNames="fizz-icon-16" />
    </p>
  </div>
</button>
